export const APK_FILENAME = "dh-hrm-app.apk";
export const APP_VERSION = "v2.0.0";
